import axios from '@/plugins/axios'
import alert from '@/plugins/alert'
import api, { Staff, Upload } from '../../plugins/api'

const USER_API = '/users/'
const STAFF_COUNT_API = '/staff/count'
const STAFF_API = '/staff/'
// const UPLOAD_API = '/upload/'
// const DESTROY_API = '/upload/files/'

export default {
  namespaced: true,
  state: {
    staffs: [],
    staff: {},
    count: 0,
    avatar: {}
  },
  actions: {
    uploadAvatar({ commit }, formData) {
      return Upload.upload(formData)
        .then(response => {
          // commit('setAvatar', response[0])
        })
        .catch(e => {
          console.error(e)
          throw e
        })
    },
    destroyAvatar({ commit }, id) {
      return Upload.destroy(id)
        .then(staff => {
          // commit('setAvatar', null)
        })
        .catch(e => {
          console.error(e)
          // throw e
        })
    },

    fetchStaffsCount({ commit }, filters = []) {
      const params = { _limit: -1 }
      filters.forEach(f => {
        if (f.value === 0 || f.value) {
          params[f.key + (f.type ? '_' + f.type : '')] = f.value
        }
      })
      return axios
        .get(STAFF_COUNT_API, { params })
        .then(count => {
          commit('setCount', count || 0)
        })
        .catch(e => alert.error(e))
    },
    fetchStaffs({ commit }, query = '') {
      return axios
        .get(STAFF_API + query)
        .then(staffs => commit('setStaffs', staffs))
        .catch(e => alert.error(e))
    },
    async fetchStaff({ commit }, id) {
      try {
        const staff = await Staff.fetchOne(id)
        commit('set1Staff', staff)
        return staff
      } catch (error) {
        console.error(error)
      }
    },
    fetchStaffsByTitle({ dispatch }, keyword) {
      if (!keyword) return
      return dispatch('fetchStaffs', {
        params: { title_contains: keyword },
        hideLoading: true
      })
    },

    async createStaff({ commit, rootGetters }, data) {
      try {
        const user = await api.User.create({ ...data })
        if (user) {
          data.user = user.id
          data.code = user.username
          const staff = await api.Staff.create({ ...data })
          commit('setStaff', staff)
          commit('receiveStaff', staff)
          alert.success('Create staff successfully!')
        } else {
          alert.error('Tạo Thất Bại!')
        }
      } catch (error) {
        console.error(error)
      }
    },
    updateStaff({ commit, state }, { id, ...staff }) {
      return axios
        .put(STAFF_API + id, staff)
        .then(staff => {
          commit('setStaff', staff)
          commit('receiveStaff', staff)
          alert.success('Update staff successfully!')
        })
        .catch(e => alert.error(e))
    },
    async updateStaffs({ dispatch }, staffs) {
      for (let item of staffs) {
        await dispatch('updateStaff', item)
      }
    },
    async removeStaff({ commit }, staff) {
      if (staff.user) {
        await axios.delete(USER_API + staff.user).catch(e => alert.error(e))
      }
      await axios
        .delete(STAFF_API + staff.id)
        .then(staff => {
          commit('removeStaff', staff.id)
        })
        .catch(e => alert.error(e))
    },
    async removeStaffs({ dispatch }, items) {
      for (let item of items) {
        await dispatch('removeStaff', item)
      }
    },
    setStaff({ commit }, staff) {
      commit('setStaff', staff)
    },
    setStaffs({ commit }, staffs) {
      commit('setStaffs', staffs)
    }
  },
  mutations: {
    setStaffs(state, staffs) {
      state.staffs = staffs
    },
    addStaff(state, ...staffs) {
      state.staffs.push(...staffs)
    },
    set1Staff(state, staff) {
      let match = false
      state.staffs = state.staffs.map(i => {
        match = match || i.id === staff.id
        return i.id === staff.id ? staff : i
      })
      if (!match) {
        state.staffs.push(staff)
      }
    },
    setStaff(state, staff) {
      state.staff = staff
    },
    setCount(state, count) {
      state.count = count
    },
    receiveStaff(state, staff) {
      const i = state.staffs.findIndex(d => d.id === staff.id)
      if (i > -1) {
        state.staffs.splice(i, 1, staff)
      } else {
        state.staffs.unshift(staff)
      }
    },
    removeStaff(state, staffId) {
      const i = state.staffs.findIndex(({ id }) => id === staffId)
      if (i > -1) {
        state.staffs.splice(i, 1)
      }
    }
  },
  getters: {
    staffs: state => {
      return state.staffs
    },
    staff: state => {
      return state.staff || {}
    }
  }
}
